var config = {
  burgAppid: "88d79c29c7ce1bfd07f7afb7897511a7",
  userAddDevice: "/device/adddevicebyadmin/",
  addDeviceuser: "/auth/regist/",
  fixedLayout: true,
  hideLogoOnMobile: false,
  isAdminInApp: false
};

Object.assign(
  config,
  process.env.APP_ENV === "develop-burg"
    ? {
      serverURI: "https://mysystemapi.burg.dinsafer.com",
      // blackhole后台前端地址
      blackholeURI: "https://mysystem.dinsafer.com",
      // burg服务器地址
      blackholeServerURI: "https://api.burg.dinsafer.com"
    }
    : {
      serverURI: "https://mysystemapi.dinsafer.com",
      asServerURI: "https://myapi-as01.dinsafer.com",
      // 后台系统地址
      // serverURI: 'https://testadminapi.dinsafer.com',
      // asServerURI: 'https://testadminapi.dinsafer.com',
      // serverURI: 'http://localhost:7792',
      // asServerURI: 'http://localhost:7792',
      // burg前端地址
      burgURI: "https://mysystem.burg.dinsafer.com",
      burgAppid: "88d79c29c7ce1bfd07f7afb7897511a7",
      // cn前端地址
      cnURI: 'https://m-zero.dinsafer.com',
      cnAppid: '67fb585f2ac4f032c1bf38e85f680afc',

      // 后台服务器地址
      // blackholeServerURI: 'https://test.dinsafer.com',
      // blackholeServerURI: 'http://yun.plutomen.com',
      blackholeServerURI: "https://api.dinsafer.com",
      buildVersion: "1.3.2",
      buildSHA: "74ec6d0"
    }
);

if (process.env.NODE_ENV === "testing") {
  if (location.host === 'my-test.dinsafer.com') {
    config.serverURI = "https://myapi-test.dinsafer.com";
    config.asServerURI = "https://myapi-test.dinsafer.com";
  } else {
    config.serverURI = "https://testadminapi.dinsafer.com";
    config.asServerURI = "https://testadminapi.dinsafer.com";
  }
  config.blackholeServerURI = "https://test.dinsafer.com";
} else if (process.env.NODE_ENV === "development") {
  if (process.env.SERVER_URI) {
    config.serverURI = process.env.SERVER_URI;
    config.asServerURI = process.env.SERVER_URI;
  } else {
    config.serverURI = "http://localhost:7792";
    config.asServerURI = "http://localhost:7792";
  }
  config.blackholeServerURI = "https://test.dinsafer.com";
}

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js